import ApiGatewayFunction from "../../UserConfigs/ApiGatewayFunction.js";

/** Deletes an asset from its brand's index entirely. Does not remove any export files already uploaded to S3 for it. */
export async function deleteAsset(appConfig, { brandId, assetId }, setIsLoading, setApiResponse) {
  const payload = {
    request_type: "studio/create_asset",
    request_sub_type: "delete_asset",
    client_id: appConfig.clientId,
    brand_id: brandId,
    asset_id: assetId,
  };

  const response = await ApiGatewayFunction(
    payload,
    appConfig.patternAPI,
    appConfig.support_key,
    appConfig.support_id,
    setIsLoading,
    setApiResponse,
    appConfig.testingState
  );

  if (!response?.data?.deleted) {
    throw new Error(response?.data?.error || "Couldn't delete this asset");
  }
  return true;
}